import styled from '@emotion/styled';

export const PatientAccountingWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const IconsContainer = styled.div`
    position: relative;
`;

export const TabWrapper = styled.div`
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 1111;
    top: 10px;
`;

export const TabContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
`;